import { useEffect, useState } from "react";

import api from "../../utils/api/axios";
import { useAppDispatch, useAppSelector } from "../../store/hook";
import { setAuthUser } from "../../store/reducers/auth.slice";
import { UserLogin } from "../../types/api/user";

import Hero from "../../components/home/Hero";
import DiscoverEpopi from "../../components/home/DiscoverEpopi";
import HomeCategories from "../../components/home/HomeCategories";
import RecentSheets from "../../components/home/RecentSheets";
import EpopiOnSmartphone from "../../components/home/EpopiOnSmartphone";
import PrescriptionAnnouncementModal from "../../components/PrescriptionAnnouncementModal";
import { isPrescriptionAnnouncementActive } from "../../utils/announcement";
import {
  COOKIE_CONSENT_EVENT,
  hasConsentChoice,
} from "../../utils/cookieConsent";

import "./Home.css";

const Home = () => {
  const dispatch = useAppDispatch();

  const auth = useAppSelector((state) => state.auth);
  const { isAuth, hasNoNetwork } = auth;

  // Pop-up d'annonce affiché à chaque ouverture de la page d'accueil
  // pendant la fenêtre définie dans utils/announcement.ts.
  // On attend que le choix cookies soit fait pour ne pas être masqué par
  // la bannière de consentement.
  const [showAnnouncement, setShowAnnouncement] = useState(
    () => isPrescriptionAnnouncementActive() && hasConsentChoice()
  );

  useEffect(() => {
    if (!isPrescriptionAnnouncementActive() || hasConsentChoice()) return;
    const handleConsent = () => {
      if (hasConsentChoice()) setShowAnnouncement(true);
    };
    window.addEventListener(COOKIE_CONSENT_EVENT, handleConsent);
    return () =>
      window.removeEventListener(COOKIE_CONSENT_EVENT, handleConsent);
  }, []);

  const getMe = async () => {
    try {
      const { data } = await api.get<UserLogin>("/auth/me");
      if (data) {
        dispatch(setAuthUser(data));
      }
    } catch (_) {}
  };

  useEffect(() => {
    if (isAuth && !hasNoNetwork) getMe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuth]);

  return (
    <>
      <Hero isAuth={isAuth} />
      {!isAuth && <DiscoverEpopi />}
      <HomeCategories isAuth={isAuth} />
      {isAuth && <RecentSheets />}
      {isAuth && <EpopiOnSmartphone />}
      {showAnnouncement && (
        <PrescriptionAnnouncementModal
          open={showAnnouncement}
          onClose={() => setShowAnnouncement(false)}
        />
      )}
    </>
  );
};

export default Home;
